// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "Inter";
}

.styles_container__texts__xoRnr {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
  color: #fff;
}

.styles_container__texts__xoRnr h1 {
  font-weight: 500;
  font-size: 1rem;
}

.styles_container__texts__xoRnr spam {
  font-weight: 300;
  align-self: flex-start;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/AlertNotification/styles.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB","sourcesContent":["* {\n  font-family: \"Inter\";\n}\n\n.container__texts {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  justify-content: center;\n  color: #fff;\n}\n\n.container__texts h1 {\n  font-weight: 500;\n  font-size: 1rem;\n}\n\n.container__texts spam {\n  font-weight: 300;\n  align-self: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container__texts": `styles_container__texts__xoRnr`
};
export default ___CSS_LOADER_EXPORT___;
